module.exports = __webpack_public_path__ + "static/neon@2x-8b322cd6e336a9a9318d824f8005870e.png";